import { render } from "./AssistantSources.vue?vue&type=template&id=ab6cab8e&scoped=true"
import script from "./AssistantSources.vue?vue&type=script&lang=js"
export * from "./AssistantSources.vue?vue&type=script&lang=js"

import "./AssistantSources.vue?vue&type=style&index=0&id=ab6cab8e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab6cab8e"]])

export default __exports__